import { createFileRoute, notFound } from '@tanstack/react-router';
import { isUuid } from '@leanin/shared';
import { EDITABLE_TITLE_RELOAD } from '@/lib/analytics/page-meta';
import { loadAdminResourceMeta } from '@/lib/queries/admin';
import { AdminResourceDetailView } from '@/components/admin/AdminResourceDetailView';
import { AdminShell } from '@/components/admin/AdminShell';
import { PLATFORM_ADMIN_ITEMS } from '@/components/admin/admin-sidebar-items';

export const Route = createFileRoute('/_authed/admin/resources/$id/')({
  beforeLoad: ({ params }) => {
    if (!isUuid(params.id)) throw notFound();
  },
  loader: {
    handler: ({ params, context: { queryClient } }) =>
      loadAdminResourceMeta(queryClient, params.id),
    staleReloadMode: EDITABLE_TITLE_RELOAD,
  },
  pendingComponent: AdminResourceDetailPending,
  component: AdminResourceDetailPage,
});

// The view renders nothing until its data lands, so pending is the shell
// alone, exactly what a slow fetch showed before the loader existed.
function AdminResourceDetailPending() {
  return <AdminShell items={PLATFORM_ADMIN_ITEMS} active="resources">{null}</AdminShell>;
}

function AdminResourceDetailPage() {
  const { id } = Route.useParams();
  return (
    <AdminShell items={PLATFORM_ADMIN_ITEMS} active="resources">
      <AdminResourceDetailView id={id} />
    </AdminShell>
  );
}
